import { createContext } from 'react'

export type ContextValue = {
  tabValue: string | null
  setTabValue: (value: string) => void
}

export const defaultContextValue: ContextValue = {
  tabValue: null,
  setTabValue: () => {},
}

export const MyPageContext = createContext<ContextValue>(defaultContextValue)
